import { api } from '../api';
import { DashboardCard } from '@/components/dashboard/dashboard-card.type';

export interface Event {
    id: string;
    name: string;
    attributes: {
        eventId: [string];
        type?: [string];
        typeDescription?: [string];
        momentusLink: [string];
        neureuterLink?: [string];
        supportLink: [string];
        supportLinkEn?: [string];
        startDate: [string];
        endDate: [string];
        iconId: [string];
        status: [string];
        momentusEnabled?: [string];
        neureuterEnabled?: [string];
        axessEnabled: [string];
        axessMailSent: [string];

        customProviderEnabled?: [string];
        pavilionEnabled?: [string];
        hiddenFromExhibitors?: [string];
        customProvider: [string];
        legalName1: [string];
        legalName2: [string];
        pavilionLinks?: [string]; // Stores array of JSON strings with pavilion link mappings
        [key: string]: [string] | undefined; // Allow dynamic attributes like PavilionLink_X, PavilionLinkName_X
    };
}

export interface SyncEventSetting {
    eventId: number;
    name: string;
    status: number;
    startDate: string;
    endDate: string;
    enabled: boolean;
}


export const EventApi = {
    getAll: () => api.get<Event[]>('/api/events'),
    getAllAdmin: () => api.get<Event[]>('/api/events/admin'),
    create: (event: Omit<Event, 'id'>) => api.post<Event, typeof event>('/api/events', event),
    updateMomentusLink: ({ id, momentusLink }: { id: string, momentusLink: string }) => api.put<Event>(`/api/events/update-momentus-link`, { id, momentusLink }),
    updateNeureuterLink: ({ id, neureuterLink }: { id: string, neureuterLink: string }) => api.put<Event>(`/api/events/update-neureuter-link`, { id, neureuterLink }),
    updateSupportLink: ({ id, supportLink, supportLinkEn, contactPhone, contactMail }: { id: string, supportLink?: string, supportLinkEn?: string, contactPhone?: string, contactMail?: string }) => api.put<Event>(`/api/events/update-support-link`, { id, supportLink, supportLinkEn, contactPhone, contactMail }),
    updateCustomProvider: ({ id, customProvider }: { id: string, customProvider: string[] }) => api.put<Event>(`/api/events/update-custom-provider`, { id, customProvider }),
    updatePavilionLinks: ({ id, pavilionLinks }: { id: string, pavilionLinks: string[] }) => api.put<Event>(`/api/events/update-pavilion-links`, { id, pavilionLinks }),
    activateMomentus: ({ id }: { id: string }) => api.put<Event>(`/api/events/activate-momentus`, { id }),
    deactivateMomentus: ({ id }: { id: string }) => api.put<Event>(`/api/events/deactivate-momentus`, { id }),
    activateNeureuter: ({ id }: { id: string }) => api.put<Event>(`/api/events/activate-neureuter`, { id }),
    deactivateNeureuter: ({ id }: { id: string }) => api.put<Event>(`/api/events/deactivate-neureuter`, { id }),
    activateAxess: ({ id }: { id: string }) => api.put<Event>(`/api/events/activate-axess`, { id }),
    deactivateAxess: ({ id }: { id: string }) => api.put<Event>(`/api/events/deactivate-axess`, { id }),

    activateCustomProvider: ({ id }: { id: string }) => api.put<Event>(`/api/events/activate-custom-provider`, { id }),
    deactivateCustomProvider: ({ id }: { id: string }) => api.put<Event>(`/api/events/deactivate-custom-provider`, { id }),
    activatePavilion: ({ id }: { id: string }) => api.put<Event>(`/api/events/activate-pavilion`, { id }),
    deactivatePavilion: ({ id }: { id: string }) => api.put<Event>(`/api/events/deactivate-pavilion`, { id }),
    hideFromExhibitors: ({ id }: { id: string }) => api.put<Event>(`/api/events/hide-from-exhibitors`, { id }),
    showToExhibitors: ({ id }: { id: string }) => api.put<Event>(`/api/events/show-to-exhibitors`, { id }),
    getSyncSettings: () => api.get<SyncEventSetting[]>('/api/events/sync-settings'),
    updateSyncSetting: ({ eventId, enabled }: { eventId: number, enabled: boolean }) => api.put<SyncEventSetting[]>('/api/events/sync-settings', { eventId, enabled }),
    getCards(id: string) {
        return api.get<DashboardCard[]>('/api/events/' + id + '/cards');

    },
    sendAxessActivationMail: ({ id }: { id: string }) => api.post<Event>(`/api/events/send-axess-mail`, { id }),
    sendWelcomeMail: ({ eventId }: { eventId: string }) => api.post<Event>(`/api/events/send-welcome-mail`, { eventId }),
    getAxessMailRecipientCount: (id: string) => api.get<{ count: number }>(`/api/events/${id}/axess-mail-recipient-count`),
    getWelcomeMailRecipientCount: (id: string) => api.get<{ count: number }>(`/api/events/${id}/welcome-mail-recipient-count`),
};
